/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountryParametersSchema } from '../models/CountryParametersSchema';
import type { CountrySchema } from '../models/CountrySchema';
import type { CreateVisitReviewSchema } from '../models/CreateVisitReviewSchema';
import type { FyzionSignerVersionSchema } from '../models/FyzionSignerVersionSchema';
import type { PublicCompanyReviewSchema } from '../models/PublicCompanyReviewSchema';
import type { ReservationServiceSchema } from '../models/ReservationServiceSchema';
import type { ReservationUserSchema } from '../models/ReservationUserSchema';
import type { ServiceGroupSchema } from '../models/ServiceGroupSchema';
import type { VisitReviewSchema } from '../models/VisitReviewSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PublicApi {
    /**
     * Create Visit Review
     * Create visit review for selected visit.
     * @returns VisitReviewSchema Created
     * @throws ApiError
     */
    public static publicCreateVisitReviewPost({
        requestBody,
    }: {
        requestBody: CreateVisitReviewSchema,
    }): CancelablePromise<VisitReviewSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/public/visit-review/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Public Company Reviews
     * Get public country parameters
     * @returns PublicCompanyReviewSchema OK
     * @throws ApiError
     */
    public static publicGetPublicCompanyReviewsGet({
        companyId,
    }: {
        companyId: string,
    }): CancelablePromise<PublicCompanyReviewSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/public/company/reviews/{company_id}',
            path: {
                'company_id': companyId,
            },
        });
    }
    /**
     * Get Countries List
     * Get public country parameters
     * @returns CountrySchema OK
     * @throws ApiError
     */
    public static publicGetCountriesListGet(): CancelablePromise<Array<CountrySchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/public/countries',
        });
    }
    /**
     * Get Country Parameters
     * Get public country parameters
     * @returns CountryParametersSchema OK
     * @throws ApiError
     */
    public static publicGetCountryParametersGet(): CancelablePromise<CountryParametersSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/public/',
        });
    }
    /**
     * Get Fyzion Signer Version
     * Get the latest released version of the Fyzion Signer desktop app, so the frontend can warn about an outdated installation. Public, no permission required.
     * @returns FyzionSignerVersionSchema OK
     * @throws ApiError
     */
    public static publicGetFyzionSignerVersionGet(): CancelablePromise<FyzionSignerVersionSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/public/fyzion-signer/version',
        });
    }
    /**
     * Get Public Company Employees
     * Get company employees that have online booking enabled (based on individual employee settings).
     * @returns ReservationUserSchema OK
     * @throws ApiError
     */
    public static publicGetPublicCompanyEmployeesGet({
        companyId,
    }: {
        companyId: string,
    }): CancelablePromise<Array<ReservationUserSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/public/company/{company_id}/employees',
            path: {
                'company_id': companyId,
            },
        });
    }
    /**
     * Get Public Company Service Groups
     * Get company service groups that have at least one service with online booking enabled.
     * @returns ServiceGroupSchema OK
     * @throws ApiError
     */
    public static publicGetPublicCompanyServiceGroupsGet({
        companyId,
    }: {
        companyId: string,
    }): CancelablePromise<Array<ServiceGroupSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/public/company/{company_id}/service-groups',
            path: {
                'company_id': companyId,
            },
        });
    }
    /**
     * Get Public Company Services
     * Get company services that have online booking enabled (based on individual service settings).
     * @returns ReservationServiceSchema OK
     * @throws ApiError
     */
    public static publicGetPublicCompanyServicesGet({
        companyId,
    }: {
        companyId: string,
    }): CancelablePromise<Array<ReservationServiceSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/public/company/{company_id}/services',
            path: {
                'company_id': companyId,
            },
        });
    }
}
